import React from 'react';
import styled, { css } from 'styled-components';
import Img from 'gatsby-image';

import device from '../utils/device';
import { isDateInPast } from '../utils/date';
import VideoOverlay from './VideoOverlay';
import Vimeo from './Vimeo';

const margin = 1.6;
const marginDesktop = 20;

const Container = styled.div`
  display: flex;
  overflow-x: visible;
  transition: transform 0.7s ease-in-out;

  transform: translateX(
    calc(-${(p) => p.index * 100}vw + ${(p) => p.index * margin * 1.5}rem)
  );

  @media ${device.desktop} {
    transform: translateX(
      calc(
        -${(p) => p.index * 100}vw + ${(p) => p.index * marginDesktop * 1.5}vw
      )
    );
  }
`;

const Wrapper = styled.div`
  overflow: hidden;
  padding-bottom: 1rem;
`;

const VideoWrapper = styled.div`
  flex: 0 0 auto;

  padding: 0 ${margin / 4}rem;
  padding-bottom: 1rem;

  :first-of-type {
    padding-left: ${margin}rem;
  }

  :last-of-type {
    padding-right: ${margin}rem;
  }

  @media ${device.desktop} {
    padding: 0 ${marginDesktop / 4}vw;

    :first-of-type {
      padding-left: ${marginDesktop}vw;
    }

    :last-of-type {
      padding-right: ${marginDesktop}vw;
    }
  }
`;

const VideoContainer = styled.div`
  width: calc(100vw - ${margin * 2}rem);
  box-shadow: 0.23rem 0.23rem 0 rgba(0, 0, 0, 0.25);
  position: relative;

  ${(p) =>
    !p.isAvailable &&
    css`
      background: ${({ theme }) => theme.colors.white};
      .gatsby-image-wrapper {
        opacity: 0.5;
      }
      box-shadow: 0.23rem 0.23rem 0 rgba(0, 0, 0, 0.125);
    `}

  @media ${device.desktop} {
    width: ${100 - marginDesktop * 2}vw;
    box-shadow: 0.8rem 0.8rem 0 rgba(0, 0, 0, 0.25);

    ${(p) =>
      !p.isAvailable &&
      css`
        box-shadow: 0.8rem 0.8rem 0 rgba(0, 0, 0, 0.125);
      `}
  }
`;

const Video = ({ video, isAvailable, onClick }) => {
  return (
    <VideoWrapper>
      <VideoContainer isAvailable={isAvailable}>
        {isAvailable && video.vimeoId ? (
          <Vimeo vimeoId={video.vimeoId} onClick={onClick} />
        ) : (
          <>
            <Img fluid={video.cover.childImageSharp.fluid} onClick={onClick} />
            <VideoOverlay video={video} />
          </>
        )}
      </VideoContainer>
    </VideoWrapper>
  );
};

const VideoCarousel = ({ videos, active, setActive }) => {
  if (typeof window === 'undefined') {
    return <></>;
  }

  return (
    <Wrapper>
      <Container index={active - 1}>
        {videos.map((v) => {
          const isAvailable = isDateInPast(v.releaseDate);
          return (
            <Video
              key={v.id}
              video={v}
              isAvailable={isAvailable}
              onClick={() => setActive(v.id)}
            />
          );
        })}
      </Container>
    </Wrapper>
  );
};

export default VideoCarousel;
